<template>
	<div class="js-error alert alert-danger">
		<dl class="js-error-description">
			<dt class="js-error-description"> <slot name="module">JavaScript Parser</slot> Error</dt>
			<dd class="js-error-description"><b><code class="alert-danger" v-html="fragment.message"></code></b><br/></dd>

			<dt class="js-error-description">Zeile</dt>
			<dd class="js-error-description"><code class="alert-danger">{{fragment.line === -1 ? 'N/A': fragment.line}}</code></dd>

			<dt class="js-error-description">Spalte</dt>
			<dd class="js-error-description"><code class="alert-danger">{{fragment.column === -1 ? 'N/A' : fragment.column }}</code></dd>
		</dl>
	</div>
</template>

<script>
	/**
	 *
	 * diese Komponent ist bewusst mit dem Name ohne "fragment" bennanten wurde, denn das Komponent nicht
	 * zu Fragementen gehört.
	 *
	 * fragement = {
	 *     "message": "Error message from parser",
	 *     "line": 12,
	 *     "column": 5
	 * }
	 * */
	export default {
		name: "js-error",
		props:["fragment"]
	};
</script>

<style scoped>
	dl.js-error-description {
		padding: 0 ;
		margin: 0;
	}
	dt.js-error-description {
		float: left;
		clear: left;
		width: 80px;
		text-align: right;
		font-weight: normal;
	}
	dt.js-error-description::after {
		content: ":";
	}
	dd.js-error-description {
		margin: 0 0 0 83px;
		padding: 0 0 0.5em 0;
	}
</style>